export default __webpack_public_path__ + "static/3-562a572b38e52bb823ecbec7291ff742.png";